import { RequestContext, GetPreferencesInput } from 'DVWebNodeUtils'

export const getPreferencesInput = (context: RequestContext) =>
  ({
    context,
    customerBasedPreferences: [
      'OptOutHdcp',
      'OptOutHdOnly',
      'OptOutUnsupportedDevice'
    ]
  } as GetPreferencesInput)
